export class ApiResponseError {

    constructor(code: string, message: string) {
        this.code = code;
        this.message = message;
    }

    /**
     * Short code for this error.
     */
    code: string;

    /**
     * Longer message for the error which can be shown to the user.
     */
    message: string;
}